(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-video-pro"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  var button = event.target.closest('[data-k7-sound]');
  if (!button) return;
  var section = button.closest('.k7-hero-video');
  var video = section && section.querySelector('video');
  if (!video) return;
  video.muted = !video.muted;
  button.setAttribute('aria-pressed', String(!video.muted));
  button.textContent = video.muted ? 'Play with sound' : 'Mute video';
});

  } catch(e) { console.error(e); }
})();
})();
